import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RESPONSE } from '@nguniversal/express-engine/tokens';

@Injectable({
  providedIn: 'root',
})
export class RedirectionService {
  res = inject(RESPONSE, { optional: true });
  router = inject(Router);

  hasRedirected = false;

  serverRedirect(url: string): void {
    if (this.res) {
      this.res.redirect(301, url);
      this.res.end();
    } else {
      this.router.navigateByUrl(url);
    }
  }
}
